import {
    NEW_NOTIFICATIONS,
    SHOW_MODAL
} from '../actions/topbarNotificationsActions';


const initialState = {
    notifications: [],
    modal: false,

} // END initialState


export default function (state = initialState, action) {
  let { payload } = action, newState;
  switch (action.type) {
      case NEW_NOTIFICATIONS:
          newState = { notifications: payload };
          return { ...state, ...newState };

      case SHOW_MODAL:
          return {...state, ...payload };

      default:
          return state;

  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/topbarNotificationsReducer.js